import axios from './axios'

export function requestPasswordReset (credentials) {
  return axios.post('/password/email', credentials)
}

export function requestResetPassword (informations) {
  return axios.post('/password/reset', informations)
}

export function fetchUser (options) {
  return axios.get('/whoami')
}

export default {
  requestPasswordReset,
  requestResetPassword,
  fetchUser
}



// WEBPACK FOOTER //
// ./src/services/auth.js